// The dashboard backend URL comes from the frontend environment.
const apiUrl = process.env.REACT_APP_BACKEND_URL;

// All HVAC requests use the same authenticated backend route.
async function request(path, options = {}) {
  const response = await fetch(`${apiUrl}hvac-equipment${path}`, {
    // Use the user's login cookie for every equipment request.
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    ...options,
  });
  // Read the backend response before returning it or showing its error message.
  const payload = await response.json();
  if (!response.ok) throw new Error(payload.error || payload.message || 'HVAC Equipment request failed');
  return payload;
}

// Used by Building Management, Edit Device, and the HVAC page filters.
export const getHvacEquipment = buildingId => request(`?building_id=${encodeURIComponent(buildingId)}`);

// Only Building Management creates, edits, or deletes equipment.
export const createHvacEquipment = data =>
  request('', { method: 'POST', body: JSON.stringify(data) });

// The equipment ID stays in the URL. The edited fields stay in the JSON body.
export const updateHvacEquipment = (id, data) =>
  request(`/${id}`, { method: 'PUT', body: JSON.stringify(data) });

// Deleting equipment also makes the database remove its ID from linked devices.
export const deleteHvacEquipment = id => request(`/${id}`, { method: 'DELETE' });
